import React, { ReactEventHandler } from "react";
import { Ticket } from "lucide-react";
import {
    KTMScreen,
    ActionEvent,
    RenderEvent,
    renderScreen,
    Sidebar,
    FileUpload,
    ColorSwatch,
} from "ktm-ui";
import {KTMApi} from "api/KTMApi";
import {
    Layout,
    RecordHeader,
    TabSet,
    Tab,
    Display,
    Button,
    Column,
    Panel,
    Line,
    Card,
} from "ktm-ui";
import toastr from "toastr";
import axios from "axios";
import ProductsScreen from "./Products";
import Cost_centresScreen from "./Cost_centres";
import DivisionsScreen from "./Divisions";
import Limit_previewScreen from "./Limit_preview";
import ActivationScreen from "./Activation";
import EmployeesScreen from "./Employees";
import EmployeesScreenMigration from "./Employees_migration";
import AssignPlanadmin from "./Assign_Planadmin";
import Year_dashboardScreen from "./Year_dashboard";
import Edit_detailsScreen from "./Edit_details";
import Edit_plan_adminScreen from "./Edit_plan_admin";
import Edit_policy_holderScreen from "./Edit_policy_holder";
import Change_policy_holderScreen from "./Change_policy_holder";
import Edit_noteScreen from "./Edit_note";
import Add_first_yearScreen from "./Add_first_year";
import Edit_first_yearScreen from "./Edit_first_year";
import CustomToolTip from "../../components/CustomToolTip";
import CampaignScreen from "./Campaign";
import FixedCampaignScreen from "./Fixed_Plan_Campaign";
import Inactive_PlanAdmins from "./Inactive_PlanAdmins";
import SettingsScreen from "../../components/Settings";
import PolicyLogs from "../policy/Policy_log";
import OpsPolicyReports from "./OpsPolicyReports";
import Benefit_Categories_New from "./Benefit_Categories_New";
import Benefit_Categories from "./Benefit_categories";
import "../../styles/Ops.css";
import BillingTeladoc from "../../ops/BillingTeladoc";

interface IdsPolicy {
  Id: string;
  Name: string;
  PolicyNo: string;
  PolicyHolder_Id: string;
  PrimaryAdvisor_Id: string;
  EnrollmentStatus: string;
  EnrollmentNote: string;
  IsActive: boolean;
  SuspendClaims: boolean;
  DependentAge: number;
  StudentAge: number;
  TaxJurisdiction_Id: string;
  Type: string;
  TypeLabel: string;
  TaxName: string;
  CurrentBenYear_Id: string;
  WaitingPeriod: number;
  EnrollPAFirstName: string;
  EnrollPALastName: string;
  EnrollPAEmail: string;
  StartDate: string;
  HasFlex: boolean;
  EnrollmentDate: string;
  ActivationDate: string;
  HasTeladoc: boolean;
  HasCorehealth: boolean;
  Language: string;
  ContestCode: string;
  Region1: string;
  Region1Rate: number;
  Region2: string;
  Region2Rate: number;
  Region3: string;
  Region3Rate: number;
}

interface IdsPolicyHolder {
    Id: string;
    Name: string;
    DBA: string;
    MailingStreet1: string;
    MailingStreet2: string;
    MailingCity: string;
    MailingProv: string;
    MailingCountry: string;
    MailingPostalCode: string;
    Phone: string;
    ContactPerson: string;
    ContactEmail: string;
    LegalForm: string;
}

interface IdsBenefitYear {
    Id: string;
    StartDate: string;
    EndDate: string;
    RunOffClosingDate: string;
    RunoffMonths: number;
}

interface IdsPrevBenefitYear {
    Id: string;
    StartDate: string;
    EndDate: string;
    RunOffClosingDate: string;
    RunoffMonths: number;
    Status: string;
}

interface IdsPolicyBalance {
    Policy_Id: string;
    LedgerType: string;
    Balance: number;
}

export default KTMScreen(
    {name: "enroll.policy.record"},
    class extends React.Component<{ policy_id: string; preview?: any }> {
        data: {
            dsPolicy: IdsPolicy;
            dsPolicyHolder: IdsPolicyHolder;
            dsBenefitYear: IdsBenefitYear;
            dsPolicyBalance: IdsPolicyBalance;
            dsPrevBenefitYear: IdsPrevBenefitYear;
        };

        // Whether the policy has enhanced benefits in any benefit year; gates the Ops Policy Reports tab.
        hasEnhancedBenefits: boolean = false;

        render() {
            return renderScreen(this);
        }

        async start({screen}: ActionEvent) {
            screen.defaultRecord = "@dsPolicy";
            // Fire in parallel with the screen load so it adds no latency; used to gate the Ops Policy Reports tab.
            const enhancedBenefitsReq = axios
                .get(`/api/PlanAdmin/showcustomcategoryreports?policyId=${this.props.policy_id}`)
                .then(res => !!(res.data?.showHsaCustomCatReport || res.data?.showLsaCustomCatReport))
                .catch(() => false);
            await KTMApi.start(screen, {
                "@policy_id": this.props.policy_id,
            });
            this.hasEnhancedBenefits = await enhancedBenefitsReq;
            screen.title = this.data.dsPolicyHolder.Name;
            screen.setOptions("@dsBenefitYear.RunoffMonths", [
                {value: "1", label: "1 month"},
                {value: "2", label: "2 months"},
                {value: "3", label: "3 months"},
            ]);
            screen.setOptions("@dsPrevBenefitYear.RunoffMonths", [
                {value: "1", label: "1 month"},
                {value: "2", label: "2 months"},
                {value: "3", label: "3 months"},
            ]);
            await screen.triggerAction(this.configure_ui);
        }

        main({field, draw, action}: RenderEvent) {
            return (
                <Layout>
                    {draw(this.header)}
                    {draw(this.tabs)}
                    {draw(this.sidebar)}
                </Layout>
            );
        }

        header({field, draw, action}: RenderEvent) {
            

      return (
        <RecordHeader entityLabel="Policy Holder">
          {draw(this.header_bar)}
        </RecordHeader>
      );
    }

        tabs({field, draw, action}: RenderEvent) {
            if (this.data.dsPolicy.EnrollmentStatus == "Active") {
                return (
                    <TabSet>
                        <Tab label="Details" template={this.details_tab}/>
                        <Tab label="Products" template={this.products_tab}/>
                        <Tab label="Teladoc" template={this.billingteladoc_tab}/>
                        <Tab label="Benefit Categories" template={this.bencat_tab}/>
                        <Tab label="Divisions" template={this.divisions_tab}/>
                        <Tab label="Cost Centres" template={this.cost_centres_tab}/>
                        <Tab label="Employees" template={this.employees_tab}/>
                        <Tab label="Plan Admins" template={this.planadmin_tab}/>
                        {this.data.dsPolicy.HasFlex ? (
                            <Tab label="Flex Campaign" template={this.campaign_tab}/>
                        ) : (
                            <Tab label="New Year Plan" template={this.fixed_campaign_tab}/>
                        )}
                        <Tab label="Settings" template={this.settings_tab}/>
                        <Tab label="Policy Logs" template={this.policylogs_tab}/>
                        {this.hasEnhancedBenefits ? <Tab label="Ops Policy Reports" template={this.ops_policy_reports_tab}/> : <></>}
                    </TabSet>
                );
            } else if (
                this.data.dsPolicy.EnrollmentStatus == "READY" &&
                this.props.preview == "1"
            ) {
                return (
                    <TabSet>
                        <Tab label="Details" template={this.details_tab}/>
                        <Tab label="Products" template={this.products_tab}/>
                        <Tab label="Teladoc" template={this.billingteladoc_tab}/>
                        <Tab label="Benefit Categories" template={this.bencat_tab}/>
                        <Tab label="Divisions" template={this.divisions_tab}/>
                        <Tab label="Cost Centres" template={this.cost_centres_tab}/>
                        <Tab label="Employees" template={this.employees_tab}/>
                    </TabSet>
                );
            } else if (
                this.data.dsPolicy.EnrollmentStatus == "migration1" ||
                (this.data.dsPolicy.EnrollmentStatus == "migration2" &&
                    this.props.preview == "1")
            ) {
                return (
                    <TabSet>
                        <Tab label="Details" template={this.details_tab}/>
                        <Tab label="Products" template={this.products_tab}/>
                        <Tab label="Teladoc" template={this.billingteladoc_tab}/>
                        <Tab label="Benefit Categories" template={this.bencat_fullview_tab}/>
                        <Tab label="Divisions" template={this.divisions_tab}/>
                        <Tab label="Cost Centres" template={this.cost_centres_tab}/>
                        <Tab label="Employees" template={this.employees_migration_tab}/>
                        <Tab label="Plan Admins" template={this.inactive_planadmin_tab}/>
                    </TabSet>
                );
            }

            return (
                <TabSet>
                    <Tab label="Details" template={this.details_tab}/>
                    <Tab label="Products" template={this.products_tab}/>
                    <Tab label="Teladoc" template={this.billingteladoc_tab}/>
                    <Tab label="Benefit Categories" template={this.bencat_tab}/>
                    <Tab label="Divisions" template={this.divisions_tab}/>
                    <Tab label="Cost Centres" template={this.cost_centres_tab}/>
                    <Tab label="Employees" template={this.employees_tab}/>
                    <Tab label="Plan Admins" template={this.planadmin_tab}/>
                    <Tab label="Limit Preview" template={this.limit_preview_tab}/>
                    <Tab label="Activation" template={this.activation_tab}/>
                    <Tab label="Settings" template={this.settings_tab}/>
                    <Tab label="Policy Logs" template={this.policylogs_tab}/>
                    {this.hasEnhancedBenefits ? <Tab label="Ops Policy Reports" template={this.ops_policy_reports_tab}/> : <></>}
                </TabSet>
            );
        }

    header_bar({ field, draw, action }: RenderEvent) {
      let paView = null;
            if (this.data.dsPolicy.EnrollmentStatus == "Active") {
                paView = (
                    <Button
                        action={action(this.open_pa_view)}
                        label="PA View"
                        style="primary"
                    />
                );
            }

      return (
        <Line>
            <Display field={field("EnrollmentStatus")} size="medium" textStyle="bold"/>
            {this.data.dsPolicy.SuspendClaims ? (
                <span style={{ alignSelf: "center", whiteSpace: "nowrap", color: "#856404", backgroundColor: "#fff3cd", border: "1px solid #ffc107", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", fontWeight: 600 }}>
                    Policy Claims Temporarily Paused
                </span>
            ) : <></>}
            <Display field={field("PolicyNo")}/>
            {this.data.dsPolicy.HasTeladoc ? <><Display field={field("HasTeladoc")}/></> : <></>}
            <div className="RT-Static-Field">
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                    <label className="RT-Static-Field__label">
                        Enrollment Note
                    </label>
                    <Button action={action(this.edit_note)} label="Edit" style="link"/>
                </div>
                <div className="RT-Static-Field__content" 
                    style={{maxHeight: 100, overflowY: "scroll"}}
                >
                    {this.data.dsPolicy.EnrollmentNote}
                </div>
            </div>
            <Line>
             {this.data && this.data.dsPolicy && this.data.dsPolicy.Language === "FR" ? (
                <span style={{ color: "red" }}>
                    <Display field={field("Language")} />
                </span>
             ) : null}
            </Line>
            <div style={{ marginBottom: 15 }}>{paView}</div>
        </Line>
      );
    }

    details_tab({ field, draw, action }: RenderEvent) {
      let balance = null;
      if (this.data.dsPolicy.EnrollmentStatus == "Active") {
        balance = draw(this.balance);
      }

      return (
        <Panel>
          <Column>
            {draw(this.policy_details)}
            {draw(this.add_toolbar)}
            {draw(this.year_details)}
            {this.data.dsPrevBenefitYear.Status == "OPEN" && draw(this.previous_year_details)}
          </Column>
          <Column>
            {draw(this.policy_holder)}
            {balance}
          </Column>
        </Panel>
      );
    }

        products_tab({field, draw, action}: RenderEvent) {
            return <ProductsScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        billingteladoc_tab({field, draw, action}: RenderEvent) {
            return <BillingTeladoc policy_id={this.data.dsPolicy.Id}/>;
        }


        cost_centres_tab({field, draw, action}: RenderEvent) {
            return <Cost_centresScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        divisions_tab({field, draw, action}: RenderEvent) {
            return <DivisionsScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        limit_preview_tab({field, draw, action}: RenderEvent) {
            return <Limit_previewScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        bencat_fullview_tab({field, draw, action}: RenderEvent) {
            return <Benefit_Categories_New 
                        policy_id={this.data.dsPolicy.Id}
                        benyear_id={this.data.dsPolicy.CurrentBenYear_Id} 
                        reload={true}
                    />;
        }

        bencat_tab({field, draw, action}: RenderEvent) {
            return <Benefit_Categories policy_id={this.data.dsPolicy.Id} 
                                       hasTeladoc={this.data.dsPolicy.HasTeladoc} 
                                       hasCorehealth={this.data.dsPolicy.HasCorehealth}/>;
        }

        activation_tab({field, draw, action}: RenderEvent) {
            return <ActivationScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        employees_tab({field, draw, action}: RenderEvent) {
            return <EmployeesScreen policy_id={this.data.dsPolicy.Id} enrollment_status={this.data.dsPolicy.EnrollmentStatus}/>;
        }

        employees_migration_tab({field, draw, action}: RenderEvent) {
            return <EmployeesScreenMigration policy_id={this.data.dsPolicy.Id}/>;
        }

        planadmin_tab({field, draw, action}: RenderEvent) {
            return <AssignPlanadmin policy_id={this.data.dsPolicy.Id}/>;
        }

        inactive_planadmin_tab({field, draw, action}: RenderEvent) {
            return <Inactive_PlanAdmins policy_id={this.data.dsPolicy.Id}/>;
        }

        funding_tab({field, draw, action}: RenderEvent) {
            return <div></div>;
        }

        campaign_tab({field, draw, action}: RenderEvent) {
            return <CampaignScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        fixed_campaign_tab({field, draw, action}: RenderEvent) {
            return <FixedCampaignScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        settings_tab({field, draw, action}: RenderEvent) {
            return <SettingsScreen
                policyId={this.data.dsPolicy.Id}
                view={"ops"}
            />;
        }
        policylogs_tab({field, draw, action}: RenderEvent) {
            return <PolicyLogs
                     policy_id={this.data.dsPolicy.Id}

            />;
        }

        ops_policy_reports_tab({field, draw, action}: RenderEvent) {
            return <OpsPolicyReports policyId={this.data.dsPolicy.Id} hasEnhancedBenefits={this.hasEnhancedBenefits}/>;
        }

        policy_details({ field, draw, action }: RenderEvent) {
            return (
                <Card
                    label="Policy Details"
                    actions={
                        <>
                        <Button
                            action={action(this.edit_policy)}
                            label="Edit"
                            style="link"
                        />
                        </>
                    }
                >
                    <Line>
                        <Display
                        field={field("TypeLabel")}
                        toolTip={
                            <CustomToolTip
                            header="Type (options are Group or Individual) "
                            bodyContent="Marketing only field. Group accounts have employees. An individual account is a Business Owner only account."
                            />
                        }
                        />
                        <Display
                        field={field("DependentAge")}
                        toolTip={
                            <CustomToolTip
                            header="Child Age"
                            bodyContent="Typically 20, meaning coverage ends at 21."
                            />
                        }
                        />
                    </Line>
                    <Line>
                        <Display
                        field={field("StudentAge")}
                        toolTip={
                            <CustomToolTip
                            header="Student Age"
                            bodyContent="Typically 24, meaning coverage ends at 25."
                            />
                        }
                        />
                        <Display
                        field={field("TaxName")}
                        toolTip={
                            <CustomToolTip
                            header="Province"
                            bodyContent="Each claim is taxed based on the home address of the employee."
                            />
                        }
                        />
                    </Line>
                    <Line>
                        {this.data.dsPolicy.EnrollmentStatus == "Active" ?
                        <Display field={field("ActivationDate")} /> :
                        <Display field={field("EnrollmentDate")} />
                        }
                    </Line>
                    <Line>
                        <div className="RT-Static-Field">
                            <label className="RT-Static-Field__label">
                                Language
                            </label>
                            <div className="RT-Static-Field__content">
                                {this.data?.dsPolicy?.Language === "ENG"
                                    ? "English"
                                    : this.data?.dsPolicy?.Language === "FR"
                                    ? "French"
                                    : this.data?.dsPolicy?.Language}
                            </div>
                        </div>
                        <div className="RT-Static-Field">
                            <label className="RT-Static-Field__label">
                                Contest Code
                            </label>
                            <div
                                className="RT-Static-Field__content"
                                style={{ display: "flex", alignItems: "center", gap: 6 }}
                            >
                                {this.data?.dsPolicy?.ContestCode ? (
                                    <>
                                        <Ticket size={18} color="#ca8a04" aria-hidden="true" />
                                        <span>{this.data.dsPolicy.ContestCode}</span>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </Line>
                </Card>
                );
            }

            plan_admin({field, draw, action}: RenderEvent) {
                return (
                    <Card
                        label="Main Contact"
                        actions={
                            <>
                                <Button
                                    action={action(this.edit_plan_admin)}
                                    label="Edit contact"
                                    style="link"
                                />
                            </>
                        }
                    >
                        <Line>
                            <Display field={field("EnrollPAFirstName")}/>
                            <Display field={field("EnrollPALastName")}/>
                            <Display field={field("EnrollPAEmail")}/>
                        </Line>
                    </Card>
                );
            }

        year_details({ field, draw, action }: RenderEvent) {
        return (
            <Card
            label="Benefit Year Details"
            actions={
                <>
                <Button
                    action={action(this.edit_year)}
                    label="Edit"
                    style="link"
                />
                </>
            }
            >
            <Line>
                <Display
                field={field("@dsBenefitYear.StartDate")}
                toolTip={
                    <CustomToolTip
                    header="Start Date"
                    bodyContent="A policy can only be backdated up to a maximum of 2 years prior to the Benefit End Date."
                    />
                }
                />
                <Display field={field("@dsBenefitYear.EndDate")} />
                <Display
                field={field("@dsBenefitYear.RunoffMonths")}
                toolTip={
                    <CustomToolTip
                    header="RunOff Months"
                    bodyContent="Instead of days, employees have run-off month(s) to get their previous year receipts submitted."
                    />
                }
                />
            </Line>
            </Card>
            );
        }

        previous_year_details({field, draw, action}: RenderEvent) {
            return (
                <Card label="Previous year details" background="previous_year_details previous-year-section">
                    <Line>
                        <Display field={field("@dsPrevBenefitYear.StartDate")}/>
                        <Display field={field("@dsPrevBenefitYear.EndDate")}/>
                        <Display field={field("@dsPrevBenefitYear.RunoffMonths")}/>
                    </Line>
                </Card>
            );
        }

        add_toolbar({field, draw, action}: RenderEvent) {
            return (
                <div className="RT-Action-Bar">
                    <Button
                        action={action(this.add_year)}
                        label="Add Benefit Year"
                        style="add"
                    />
                </div>
            );
        }

    policy_holder({ field, draw, action }: RenderEvent) {
      return (
        <Card
          label="Policy Holder"
          actions={
            <>
              <Button
                action={action(this.edit_policy_holder)}
                label="Edit"
                style="link"
              />
              <Button
                action={action(this.change_policy_holder)}
                label="Change policy holder"
                style="link"
              />
            </>
          }
        >
          <Line>
            <Display field={field("@dsPolicyHolder.DBA")} />
            <Display field={field("@dsPolicyHolder.PreviousName")} />
            <Display field={field("@dsPolicyHolder.LegalForm")} />
          </Line>
          <Display field={field("@dsPolicyHolder.MailingStreet1")} />
          <Display field={field("@dsPolicyHolder.MailingStreet2")} />
          <Line>
            <Display field={field("@dsPolicyHolder.MailingCity")} />
            <Display field={field("@dsPolicyHolder.MailingProv")} />
          </Line>
          <Line>
            <Display field={field("@dsPolicyHolder.MailingCountry")} />
            <Display field={field("@dsPolicyHolder.MailingPostalCode")} />
          </Line>
          <Display field={field("@dsPolicyHolder.Phone")} />
        </Card>
      );
    }

        balance({field, draw, action}: RenderEvent) {
            return (
                <Card label="Balance">
                    <Display
                        field={field("@dsPolicyBalance.Balance")}
                        size="medium"
                        textStyle="bold"
                    />
                </Card>
            );
        }

        sidebar({draw}: RenderEvent) {
            return (
                <Sidebar>
                    <Tab label="Year dashboard" template={this.year_dashboard}/>
                    <Tab label="Branding" template={this.branding}/>
                </Sidebar>
            );
        }

        year_dashboard({field, draw, action}: RenderEvent) {
            return <Year_dashboardScreen policy_id={this.data.dsPolicy.Id}/>;
        }

        branding({field, draw, action}: RenderEvent) {
            return (
                <Card label="Branding">
                    {draw(this.brand_logo)}
                    {draw(this.brand_color)}
                </Card>
            );
        }

        brand_logo({field, draw, action}: RenderEvent) {
            return <FileUpload field={field("@logo")}/>;
        }

        brand_color({field, draw, action}: RenderEvent) {
            return <ColorSwatch field={field("@brandColor")}/>;
        }

        async configure_ui({screen}: ActionEvent) {
            screen.hide(this.add_year);
            screen.hide(this.year_details);
            let year = this.data.dsPolicy.CurrentBenYear_Id;

            if (!year) {
                screen.unhide(this.add_year);
            } else {
                screen.unhide(this.year_details);
            }
        }

        async edit_policy({screen}: ActionEvent) {
            await screen.openDialog(
                <Edit_detailsScreen policy_id={this.data.dsPolicy.Id}/>,
                {onRecordChanged: this.refresh_data}
            );
        }

        async edit_plan_admin({screen}: ActionEvent) {
            await screen.openDialog(
                <Edit_plan_adminScreen policy_id={this.data.dsPolicy.Id}/>,
                {onRecordChanged: this.refresh_data}
            );
        }

        async edit_policy_holder({screen}: ActionEvent) {
            await screen.openDialog(
                <Edit_policy_holderScreen
                    policyholder_id={this.data.dsPolicyHolder.Id}
                    policy_id={this.data.dsPolicy.Id}
                />,
                {onRecordChanged: this.refresh_data}
            );
            screen.recordChanged("updated", screen.getValue("@dsPolicy.Id"));
        }

        async change_policy_holder({screen}: ActionEvent) {
            await screen.openDialog(
                <Change_policy_holderScreen policy_id={this.data.dsPolicy.Id}/>,
                {onRecordChanged: this.refresh_data}
            );
        }

        async edit_note({screen}: ActionEvent) {
            await screen.openDialog(
                <Edit_noteScreen policy_id={this.data.dsPolicy.Id}/>,
                {onRecordChanged: this.refresh_data}
            );
        }

        async add_year({screen}: ActionEvent) {
            await screen.openDialog(
                <Add_first_yearScreen policy_id={this.data.dsPolicy.Id}/>,
                {onRecordChanged: this.refresh_data}
            );
        }

        async edit_year({screen}: ActionEvent) {
            await screen.openDialog(
                <Edit_first_yearScreen
                    year_id={this.data.dsPolicy.CurrentBenYear_Id}
                    policy_id={this.data.dsPolicy.Id}
                />,
                {onRecordChanged: this.refresh_data}
            );
        }

    async refresh_data({ screen }: ActionEvent) {
      await screen.restart();
    }

        async open_pa_view({screen}: ActionEvent) {
            // open the tab synchronously (popup blockers allow it on click), then
            // mint an sso ticket and point the tab at the PA portal handoff
            const tab = window.open("", "_blank");
            try {
                const response = await fetch("/api/sso/paview", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({policyId: this.data.dsPolicy.Id}),
                });
                if (!response.ok) {
                    throw new Error("mint failed: " + response.status);
                }
                const res = await response.json();
                if (tab) {
                    tab.location.href = res.url;
                } else {
                    window.location.href = res.url;
                }
            } catch (e) {
                if (tab) tab.close();
                screen.message("Could not open PA View", {style: "danger"});
            }
        }

        async generate_claims({screen}: ActionEvent) {
            const requestOptions = {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    policyId: this.data.dsPolicy.Id,
                }),
            };

            await fetch("/api/planadmin/generateclaims", requestOptions);
            toastr.success("Claims generated", "Success");
        }
    }
);
